// extracted by mini-css-extract-plugin
export default {"container":"instructionsView_container__kVUCh","title":"instructionsView_title__rSrmu","instructionsList":"instructionsView_instructionsList__fntNO"};